import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "ArrowDownColor1"
});
const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_1707_17594)"><path opacity="0.5" d="M11.0132 21.0972L3.88574 16.9822L10.2169 34.3644L27.644 30.699L21.3084 27.0411C21.6983 18.9653 27.9046 12.0954 36.1141 5.6355C36.1141 5.6355 26.8606 8.56328 21.6898 11.8673C17.0454 14.8349 11.0132 21.0972 11.0132 21.0972Z" fill="url(#paint0_linear_1707_17594)"></path></g><defs><linearGradient id="paint0_linear_1707_17594" x1="9.82011" y1="34.1357" x2="28.7344" y2="1.37523" gradientUnits="userSpaceOnUse"><stop stop-color="#E64C4C"></stop><stop offset="1" stop-color="#E64C4C" stop-opacity="0"></stop></linearGradient><clipPath id="clip0_1707_17594"><rect width="40" height="40" fill="white"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var arrowDownColor1 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { arrowDownColor1 as default };
